import { gql } from '@apollo/client';
import { templateItem } from 'features/documentTemplates/list/fragments';

export const TEMPLATES_LIST_QUERY = gql`
  query templates($pager: PagerInputNew, $filters: DocumentTemplateFilterInput) {
    templates(pager: $pager, filters: $filters) {
      total
      values {
        ...templateItem
      }
    }
  }
  ${templateItem}
`;
